import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";

import Home from "@/pages/Home";
import Flexshade from "@/pages/Flexshade";
import Velarias from "@/pages/Velarias";
import Thanks from "@/pages/Thanks";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminKanban from "@/pages/admin/AdminKanban";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminLeadDetail from "@/pages/admin/AdminLeadDetail";
import AdminStub from "@/pages/admin/AdminStub";
import AdminEmails from "@/pages/admin/AdminEmails";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";
import AdminCampaigns from "@/pages/admin/AdminCampaigns";
import AdminCampaignEditor from "@/pages/admin/AdminCampaignEditor";
import AdminCampaignDetail from "@/pages/admin/AdminCampaignDetail";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminAdsSetup from "@/pages/admin/AdminAdsSetup";
import AdminManual from "@/pages/admin/AdminManual";
import AdminDiagnostic from "@/pages/admin/AdminDiagnostic";
import ProtectedAdmin from "@/components/admin/ProtectedAdmin";

import { captureUtmParams } from "@/lib/utm";
import { captureAndPersistUtms } from "@/lib/tracker";

function App() {
    useEffect(() => { captureUtmParams(); captureAndPersistUtms(); }, []);

    return (
        <div className="App font-body" data-testid="eclipse-app-root">
            <BrowserRouter>
                <Toaster position="top-right" richColors closeButton />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/flexshade" element={<Flexshade />} />
                    <Route path="/velarias" element={<Velarias />} />
                    <Route path="/gracias" element={<Thanks />} />

                    {/* Admin */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
                    <Route path="/admin/pipeline" element={<ProtectedAdmin><AdminKanban /></ProtectedAdmin>} />
                    <Route path="/admin/leads" element={<ProtectedAdmin><AdminLeads /></ProtectedAdmin>} />
                    <Route path="/admin/leads/:id" element={<ProtectedAdmin><AdminLeadDetail /></ProtectedAdmin>} />
                    <Route path="/admin/analytics" element={<ProtectedAdmin><AdminAnalytics /></ProtectedAdmin>} />
                    <Route path="/admin/ads-setup" element={<ProtectedAdmin><AdminAdsSetup /></ProtectedAdmin>} />
                    <Route path="/admin/manual" element={<ProtectedAdmin><AdminManual /></ProtectedAdmin>} />
                    <Route path="/admin/diagnostic" element={<ProtectedAdmin><AdminDiagnostic /></ProtectedAdmin>} />
                    <Route path="/admin/emails" element={<ProtectedAdmin><AdminEmails /></ProtectedAdmin>} />
                    <Route path="/admin/subscribers" element={<ProtectedAdmin><AdminSubscribers /></ProtectedAdmin>} />
                    <Route path="/admin/campaigns" element={<ProtectedAdmin><AdminCampaigns /></ProtectedAdmin>} />
                    <Route path="/admin/campaigns/new" element={<ProtectedAdmin><AdminCampaignEditor /></ProtectedAdmin>} />
                    <Route path="/admin/campaigns/:id" element={<ProtectedAdmin><AdminCampaignDetail /></ProtectedAdmin>} />
                    <Route path="/admin/campaigns/:id/edit" element={<ProtectedAdmin><AdminCampaignEditor /></ProtectedAdmin>} />
                    <Route path="/admin/manual" element={<ProtectedAdmin><AdminStub title="Manual" phase="Fase 5 — Manual embebido del operador" /></ProtectedAdmin>} />
                    <Route path="/admin/diagnostic" element={<ProtectedAdmin><AdminStub title="Diagnóstico" phase="Fase 5 — Diagnóstico de integraciones" /></ProtectedAdmin>} />

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
